module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('mesh', {
    attrs: {
      "name": "Cube"
    }
  }, [_c('geometry', {
    attrs: {
      "type": "Box",
      "args": [_vm.size, _vm.size, _vm.size]
    }
  }), _vm._v(" "), _c('material', {
    attrs: {
      "type": "MeshBasic",
      "options": _vm.material
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-884c75e4","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./examples/Cube.vue
// module id = 167
// module chunks = 1